<template>
  <div>
    <el-button type="primary" @click="message" icon="el-icon-search">Search</el-button>
    <el-button type="primary" @click="submitForm">开始</el-button>
    <el-button type="primary" @click="clousSSE">结束</el-button>
    <div>
      输出：
      <div>{{ msg }}</div>
      <p v-for="message in messages" :key="message">{{ message }}</p>
    </div>

  </div>
</template>

<script>
import { ChatAPI } from '../../api/chat';
import axios from 'axios'

export default {
  name: 'HelloWorld',
  data() {
    return {
      msg: '',
      messages: []
    }
  },
  methods: {
    submitForm() {
      axios({
        // method: 'post',
        url: 'http://localhost:8083/api/chat/sse/test?id=123',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'text/event-stream',
          // 'Cache-Control':'no-store'
        },
        responseType: 'text',
        timeout: 0, // Set timeout to 0 to disable it
        onDownloadProgress: (progressEvent) => {
          const data = progressEvent.event.target.response
          const lines = data.trim().split('\n\n')
          const tmp = []
          lines.forEach((line) => {
            const [eventType, eventData] = line.split(':')
            if (eventType === 'data') {
              tmp.push(eventData)
            }
          })
          console.info(tmp)
          this.msg = tmp
        }
      })
    },
    clousSSE() {
      sse.close();

    },
    message() {
      this.$message({
        message: '问题不能为空',
        type: 'warning'
      });
    }
  },
  beforeDestroy() {
    // source.close();
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>





// WEBPACK FOOTER //
// src/components/test/HelloWorld.vue